export const isValid = (code?: any, number?: any) => {
  var result = number.replace(/[- )(]/g, '');
  if (code === 'IN' && result.length === 10) return true;
  else if (code === 'US' && result.length === 10) return true;
  else return false;
};
